import Role from 'constants/role';
import { useHasRole } from 'hooks/useHasRole';
import React from 'react';
import { ReferenceInput, AutocompleteInput } from 'react-admin';
import generateOptionText from 'utils/autocomplete-option-text';

const optionText = generateOptionText('title');

function OrganizationReferenceInput({ disabled, ...props }) {
  const hasRole = useHasRole();
  if (!hasRole(Role.SUPER_ADMIN)) {
    return null;
  }
  return (
    <ReferenceInput reference="organizations" allowEmpty {...props}>
      <AutocompleteInput
        defaultValue={null}
        filterToQuery={(searchText) => ({
          searchQuery: searchText,
          _attributes: 'id,title',
        })}
        optionText={optionText}
        matchSuggestion={() => true}
        disabled={disabled}
        sx={{
          width: '200px',
        }}
      />
    </ReferenceInput>
  );
}
OrganizationReferenceInput.defaultProps = {
  source: 'orgId',
  label: 'Organization',
};

export default OrganizationReferenceInput;
